<template>
  <error-page-layout
    color-type="error"
    title="Acesso restrito"
    first-message="Você não tem permissão para acessar esse conteúdo."
    second-message="Contate o administrador da sua plataforma caso queira receber acesso."
    image-name="401.png"
  >
    <mf-button slot="buttons" class="px-7" label="Voltar" @click="redirectToFirstPermission" />
  </error-page-layout>
</template>

<script>
import { mapState } from 'vuex'
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
export default {
  components: {
    ErrorPageLayout,
  },
  computed: {
    ...mapState({
      userPermissions: (state) => state.userPermissions,
    }),
  },
  methods: {
    redirectToFirstPermission() {
      const firstPermission = this.userPermissions.includes('home') || this.$getLoggedUser().only_mercapromo ? 'home' : this.userPermissions[0]

      const parent = this.$router.options.routes.find((route) => {
        if (route.meta && route.meta.pagePermission === firstPermission) return route
        else {
          if (route.children) {
            const children = route.children.find((children) => {
              if (children.meta && children.meta.pagePermission === firstPermission) return children
            })
            return children
          }
        }
      })

      if (parent.children) {
        const children = parent.children.find((children) => {
          return children.meta && children.meta.pagePermission === firstPermission
        })
        this.$router.push(`${parent.path}/${children.path}`).catch(() => {})
      } else {
        this.$router.push(`${parent.path}`).catch(() => {})
      }
    },
  },
}
</script>
